import { render } from "./FileSystem.vue?vue&type=template&id=59ecac58"
import script from "./FileSystem.vue?vue&type=script&lang=js"
export * from "./FileSystem.vue?vue&type=script&lang=js"
script.render = render

export default script